module.exports = __webpack_public_path__ + "arround3.gif?6e95c7795a1436e4c593a16e80d9feaa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arround3.gif
// module id = 829
// module chunks = 0